import React, { useMemo, useState } from "react";
import get from 'lodash/get';
import useFetchOnlineReviewByPropertiesData from "../../../../hooks/useFetchOnlineReviewByPropertiesData";
import { convertCstDataIntoTableCompatibleData, getMonthWithValues } from "../../../../../../utils/transformChartsAndTableData";
import { View } from "../../../../../../components/Common/react-native-components";
import { Dropdown, Typography } from "@hmsexp/component-library";
import { dropdownStyling } from "../../styles";
import { useSelector } from "react-redux";
import { parseFilters } from "../../../../../Filters/utils/fetchData";
import Pagination from "../../../../../../components/Common/Pagination";
import Loader from "./Loader";
import GraphTable from "../../../../../../components/Common/GraphTable";
import { FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN } from "../../../../actionTypes";
import GenericNoData from "../../../../../../components/Common/NoData/GenricNoData";

const OnlineReviewGraphTable = ({ lowSampleSize, selectedMetricOptions }) => {

    const { applied_filter_values } = useSelector(e => e?.filterReducer);
    const [selectedMetric, setSelectedMetric] = useState(get(selectedMetricOptions, '[0].value'));
    const updatedFilters = useMemo(() => {
        const filters = parseFilters(applied_filter_values);
        return {
            ...filters,
            filters: {
                ...filters.filters,
                additional_filters: {
                    ...filters.filters?.additional_filters,
                    feedback_source: [selectedMetric]
                }
            }
        };
    }, [applied_filter_values, selectedMetric]);

    const { data, onPageChange, data_per_page, isLoading, page, totalPages } = useFetchOnlineReviewByPropertiesData({
        campaign: FETCH_OVERVIEW_ONLINE_REVIEW_PROPERTIES_DRILL_DOWN_DATA_CAMPAIGN,
        customFilters: updatedFilters,
        skip: !selectedMetric
    });

    const graphTableData = convertCstDataIntoTableCompatibleData({ columns: get(data, 'cstData.columns'), metric_data: get(data, 'cstData.metric_data'), metric_count: get(data, 'cstData.metric_count') } || {});

    const graph_table_data = {
        ...graphTableData,
        table_rows: graphTableData?.table_rows?.map(row => {
            const monthData = getMonthWithValues(row);
            const options = {
                ...get(data, 'table_bar_chart_default_data'),
                xAxis: {
                    ...get(data, 'table_bar_chart_default_data.xAxis'),
                    categories: monthData.months
                },
                series: get(data, 'table_bar_chart_default_data.series', []).map((s, i) => ({
                    ...s,
                    data: i === 0 ? monthData.data : s.data
                })),

            };
            return {
                ...row,
                nested_rows: [
                    {
                        [get(graphTableData, 'table_columns[0].field')]: {
                            chart_options: options
                        }
                    }
                ]
            };
        })
    };

    if (!isLoading && !get(data, 'cstData')) {
        return <GenericNoData />
    }
    return (
        <View>
            <Typography
                textProps={{ style: { marginBottom: 5 } }}
                variant='button'
                color='primaryContentMedium'
                fontWeightType='regular'>
                {get(data, "config.dropdownLabel")}
            </Typography>
            <View style={{ maxWidth: 200 }}>
                <Dropdown
                    items={selectedMetricOptions}
                    onChange={(e) => {
                        setSelectedMetric(e)
                        onPageChange(0)
                    }}
                    value={selectedMetric}
                    label={''}
                    style={{
                        container: {
                            ...dropdownStyling.container, width: 250, minWidth: 250
                        },
                        optionContainer: dropdownStyling.optionContainer,
                        dropDownText: dropdownStyling.dropDownText,
                        icon: dropdownStyling.icon
                    }}
                />
            </View>
            {isLoading ? <Loader /> :
                <GraphTable lowSampleSize={lowSampleSize} graph_table_data={{ table_data: graph_table_data }} />
            }
            <Pagination
                currentPage={page} totalRecords={totalPages} pageSize={data_per_page} onPageChange={onPageChange}
            />
        </View >)
};

export default OnlineReviewGraphTable;  